class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = 'f18a3c65';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1125.0.2';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Mon, 25 Aug 2025 18:39:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2025-08-25 14:38:30 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2025-08-25 14:38:30 Boston - f18a3c65 - 1125.0.2';
export default BuildTags;
